import React from "react";
import { CustomButton, IconComponent } from "../../../../common/components";
import styles from "./AccessController.module.css";
import { translate } from "../../../../common/providers";

export default function AccessController({ color, icon, title, description, onClick, iconClassName, btnName }) {
	return (
		<div className={styles.container} style={{ backgroundColor: color }}>
			<div className={styles.titleContainer}>
				<div className={styles.title}>
					<IconComponent className={styles[iconClassName]} icon={icon} size="s" />
					{title}
				</div>
				<div className={styles.description}>{description}</div>
			</div>
			<div className={styles.containerAction}>
				<CustomButton variant="contained" onClick={onClick}>
					{btnName || translate("common:btn.edit")}
				</CustomButton>
			</div>
		</div>
	);
}
